import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { MenuDrawer } from '../components/MenuDrawer';
import { Hero } from '../components/Hero';
import { ConciergeRequestBar } from '../components/ConciergeRequestBar';
import { ServiceAreas } from '../components/ServiceAreas';
import { ConciergeExtras } from '../components/ConciergeExtras';
import { Destinations } from '../components/Destinations';
import { Experiences } from '../components/Experiences';
import { Faq } from '../components/Faq';
import { CallbackBar } from '../components/CallbackBar';
import { News } from '../components/News';
import { Membership } from '../components/Membership';
import { ExperientialSeries } from '../components/ExperientialSeries';
export function Home() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const {
    hash
  } = useLocation();
  useEffect(() => {
    document.title = 'Superluxury — Private Concierge, by Introduction Only';
  }, []);

  // Arriving from a subpage with a section link (e.g. /#faq) — scroll to that section
  useEffect(() => {
    if (!hash) return;
    const id = window.setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 50);
    return () => window.clearTimeout(id);
  }, [hash]);
  return <>
      <Header onOpenMenu={() => setMenuOpen(true)} data-id="element-1480" data-mp="2hy70qw5q165l" />
      <MenuDrawer open={menuOpen} onClose={closeMenu} data-id="element-1481" data-mp="2i0070acf9od2" />
      <main data-id="element-1482" data-mp="2d65rlj3unvjs">
        <Hero data-id="element-1483" data-mp="2d5mb86tulf7v" />
        {/* Tablet and mobile: request bar directly below the film */}
        <div className="lg:hidden" data-id="element-1484" data-mp="2895jz3rcqkqk">
          <ConciergeRequestBar data-id="element-1485" data-mp="2861dfzqezcwq" />
        </div>
        <ServiceAreas data-id="element-1486" data-mp="239sqw19w0hfj" />
        <ConciergeExtras data-id="element-1487" data-mp="23acb5on0fhwq" />
        <Experiences data-id="element-1488" data-mp="236y7md2m12np" />
        <Membership data-id="element-1489" data-mp="1z765oj7q1urb" />
        <Destinations data-id="element-1490" data-mp="1z7pdh73nr2rm" />
        <ExperientialSeries data-id="element-1491" data-mp="1z64khlwzrrvv" />
        <News data-id="element-1492" data-mp="1z98syvhhp9sc" />
        <Faq data-id="element-1493" data-mp="1u8coafpbdjlv" />
        <CallbackBar data-id="element-1494" data-mp="1u7t8b4j855ah" />
      </main>
    </>;
}